import React from 'react'
import { HeadProps, PageProps, graphql } from 'gatsby'
import { Main } from '../components/page'
import { Seo } from '../components/seo'
import { Blocks } from '../blocks'

type Data = Queries.PageTemplateQuery

type Ctx = {
  title: string
  slug: string
}

const PageTemplate = ({ data, ...props }: PageProps<Data, Ctx>) => {
  return (
    <Main>
      {data.page?.blocks?.map((block, index) => {
        if (!block) throw new Error(`Missing block num ${index}`)
        const type = block.__typename?.replace('Contentful', '')
        if (!type) throw new Error(`Missing block type ${type}`)
        const Block = (Blocks as any)[type]
        if (!Block) throw new Error(`Missing block type ${type}`)
        return <Block key={type} {...props} {...block} />
      })}
    </Main>
  )
}

export default PageTemplate

export const Head = ({ data }: HeadProps<Data, Ctx>) => {
  return <Seo brand={data.brand} item={data.page} />
}

export const query = graphql`
  query PageTemplate($slug: String) {
    brand: contentfulBrand(slug: { eq: "nftfi" }) {
      ...Brand
    }
    page: contentfulPage(slug: { eq: $slug }) {
      ...Page
    }
  }
`
